<template>
  <TeamComponent />
</template>

<script>
// @ is an alias to /src
import TeamComponent from "@/components/Account/Pages/Team/Team.vue";

export default {
  name: "CompanyInfo",
  components: {
    TeamComponent
  }
};
</script>
